import React, { useEffect, useState } from "react";
import CategoryCard from "../../CustomComponents/CategoryCard";
import { useNavigate } from "react-router-dom";
import "./HighlightProductCollection2.css";
const HighlightProductCollection2 = ({ data }) => {
  const navigate = useNavigate();

  const [highlightProductCollection2, setHighlightProductCollection2] =
    useState([]);
  useEffect(() => {
    if (data) {
      setHighlightProductCollection2(data);
    }
  }, [data]);

  const handleIndividualCategory = (prod) => {
    navigate(`/productsList/${prod.product_category_id}`, {
      state: {
        subCategoryId: prod.product_category_id,
        subCategoryName: prod.product_category_name,
      },
    });
  };
  // const handleViewAllClickFunc = () => {
  //   navigate("/all-categories-listing", {
  //     state: { fromRingCollection: true },
  //   });
  // };
  const handleViewAllClickFunc = (dataaa) => {
   
    navigate("/rings-collection", {
      state: { fromRingCollection: true, ringCollectionData: dataaa },
    });
  };
  return (
    <div className="ring-collection-div">
      <div className="shopByCategoryDiv">
        <div className="upperContent">
          <h1>Rings Collection</h1>
          <p>Explore our elegant rings for every occasion and style</p>
        </div>
        <div className="lowerContent">
          <div className="hrLine" />
          <div className="view-all">
            <p
              onClick={() =>
                handleViewAllClickFunc(highlightProductCollection2)
              }
            >
              View all
            </p>
          </div>

          {highlightProductCollection2?.length > 0 ? (
            <div className="cardsContainer">
              {" "}
              {/* ✅ Wrap all cards inside a single container */}
              {highlightProductCollection2?.map((prod, index) => (
                <CategoryCard
                  key={prod.id}
                  item={{
                    image: `${prod?.product_category_storage_url}`,
                    name: prod.product_category_name,
                  }}
                  onClick={() => handleIndividualCategory(prod)}
                />
              ))}
            </div>
          ) : (
            <>
              <p>No Ring collections available</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HighlightProductCollection2;
